import { render } from "./PcUpload.vue?vue&type=template&id=5aa399e4&scoped=true&ts=true"
import script from "./PcUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./PcUpload.vue?vue&type=script&setup=true&lang=ts"

import "./PcUpload.vue?vue&type=style&index=0&id=5aa399e4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa399e4"],['__file',"src/components/scan/pc/PcUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aa399e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aa399e4', __exports__)) {
    console.log('reload')
    api.reload('5aa399e4', __exports__)
  }
  
  module.hot.accept("./PcUpload.vue?vue&type=template&id=5aa399e4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5aa399e4', render)
  })

}


export default __exports__